import { type OutageStatus } from '@solinkcorp/authentication';
import { withAspen } from 'components/aspen/withAspen';
import { CommonContext } from 'components/Contexts';
import { useContext, useEffect } from 'react';
import useDimensions from 'react-cool-dimensions';
import { isMinorOutage } from 'utils/StatusUtil';
import IntegrationBanner from './IntegrationBanner/IntegrationBanner';
import IntegrationBannerAspen from './IntegrationBanner/IntegrationBannerAspen';
import MinorOutage from './MinorOutage/MinorOutage';

const IntegrationBannerGated = withAspen(IntegrationBanner, IntegrationBannerAspen);

interface AppBannersProps {
  outageStatus: OutageStatus;
}
export default function AppBanners(props: AppBannersProps) {
  const { outageStatus } = props;
  const { appState } = useContext(CommonContext);

  // Track banner height to adjust NavigationFrame layout
  // Tracking the height based on the state, requires too many conditions: local storage, isMinorOutage, showIntegrationBanner, etc.
  // The cost of making a mistake is too high, empty space at the bottom of the screen would be very noticeable.
  // Using a resize observer is more reliable as it measures the actual height of the rendered banners.
  const { observe, height } = useDimensions();

  useEffect(() => {
    appState.setBannerHeightPx(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [height]);

  return (
    <div ref={observe}>
      {isMinorOutage(outageStatus) && <MinorOutage outageStatus={outageStatus} />}
      {appState.showIntegrationBanner && !isMinorOutage(outageStatus) && (
        <IntegrationBannerGated
          setIsIntegrationBannerVisible={appState.setIsIntegrationBannerVisible}
        />
      )}
    </div>
  );
}
